

<script setup>
import { ref, watchEffect } from 'vue'

import ColorPicker from '@/tiptap/extensions/components/ColorPicker.vue'
import ActionButton from '../src/index.vue'
import { extActionButtonProps } from '../src/props'

const props = defineProps(extActionButtonProps)

// Local color state (mirrors textStyle color); avoids relying on useTiptapStore
const colorState = ref('')

function action(color) {
  const chain = props.editor.chain().focus()
  if (!color) {
    chain.unsetColor().run()
  } else {
    chain.setColor(color).run()
  }
}

function isActive() {
  const { color } = props.editor.getAttributes('textStyle')
  if (!color) return false
  return props.editor.isActive({ color }) || false
}

watchEffect(() => {
  const { color } = props.editor.getAttributes('textStyle')
  colorState.value = color || ''
})
</script>

<template>
  <ActionButton
    :editor="editor"
    icon="color"
    :tooltip="t('editor.color.tooltip')"
    :disabled="!editor.can().setColor('')"
    :color="colorState"
    :is-active="isActive"
  >
    <ColorPicker
      v-model="colorState"
      mode="color"
      activator="parent"
      :nudge-top="-4"
      :nudge-left="8"
      @change="action"
    />
  </ActionButton>
</template>